import {inlineError} from '@s-ui/decorators'
import {Repository} from '@s-ui/domain'

/**
 * @interface
 * */
export class SellerRepository extends Repository {
  /**
   * @method
   * @return {Error}
   */
  @inlineError
  saveContactDetails({adId, message, name, email, phone}) {
    throw new Error('[SellerRepository#saveContactDetails] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  @inlineError
  contactConfiguratorNotLoggedSeller({contactConfiguratorNotLoggedSellerRequest}) {
    throw new Error('[SellerRepository#contactConfiguratorNotLoggedSeller] must be implemented')
  }
}
